<template>
    <div 
      class="fill-height mt-2">
      <v-layout wrap>
        <v-flex>
          <section>
            <v-snackbar
            v-model="dialog.snackbar"
            top
            right
            color="green">
            <span 
              class="body-1 font-weight-light white--text"
              v-html="message.success">
            </span>
  
            <template v-slot:action="{ attrs }">
              <v-btn
                icon
                color="white"
                class="body-1 font-weight-bold text-capitalize"
                v-bind="attrs"
                @click="dialog.snackbar = false">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-snackbar>
          <v-dialog v-model="dialog.confirm"
            @keydown.esc="dialog.confirm = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                Konfirmasi Update Status
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.confirm = false; dialog.fullscreen = false; selected.confirm = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second mt-4">
                Apakah Anda yakin ingin mengubah status menjadi {{ selected.status }}?
              </v-card-text>
  
              <div v-if="message.error.length > 0"
                class="text-center mx-6 my-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
  
              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-actions
                class="pa-4">
                <v-spacer/>
  
                <v-btn
                  rounded
                  width="120"
                  @click="statuses()"
                  :loading="process.status"
                  :disabled="process.status"
                  color="green"
                  elevation="0"
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Ya, Ubah
                </v-btn>
  
                <v-btn
                  rounded
                  width="120"
                  @click="dialog.confirm = false; dialog.fullscreen = false; selected.confirm = [];"
                  :disabled="process.status"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-card 
            flat
            style="border-radius: 10px;">
            <v-card-text class="pa-1">
              <v-row
                class="pa-4 pb-1">
                <v-col 
                  cols="12"
                  class="py-0">
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <div class="mb-2" v-if="Object.keys(detail_project).length > 0">
                        <div class="d-flex align-center">
                          <div style="font-size: 14px; border: 1px solid #fff; color: black; border-left: none; padding: 2px 12px 2px 4px; text-align: left; width: 130px; min-width: 130px; max-width: 130px;">
                            Pilih {{ detail_project.duration_label === 'hari' ? 'Hari' : 'Minggu' }}
                          </div>
                          <div style="font-size: 14px; border: 1px solid #fff; color: black; border-left: none; padding: 2px 12px; text-align: center; width: 1px; white-space: nowrap;">
                            :
                          </div>
                          <div style="font-size: 14px; border: 1px solid #fff; color: black; border-left: none; padding: 2px 2px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;">

                            <ValidationProvider 
                              :name="`Pilih ${detail_project.duration_label === 'hari' ? 'Hari' : 'Minggu'}`" 
                              :rules="`required`" 
                              v-slot="{ errors, valid }">
                              <v-autocomplete
                                
                                filled
                                rounded
                                dense
          
                                :color="set_color"
                                :placeholder="`Pilih ${detail_project.duration_label === 'hari' ? 'Hari' : 'Minggu'}`"
                                :items="count_week_list"
                                item-text="value"
                                item-value="id"
          
                                hide-details
                                v-on:change="fetchDetailRealisasiKemajuanPekerjaanWeek()"
          
                                v-model="selected.week"
                                :success="selected.week !== '' && valid"
                                :error-messages="errors"
                                required
                                class="mb-0 fs-12 little-placeholder-autocomplate"
                                style="border-radius: 6px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
                          </div>
                        </div>
                      </div>
                      <v-divider class="my-2"></v-divider>
                      <v-card-text
                        v-if="Object.keys(data_week).length === 0 && !process.load"
                        class="pb-0 my-4" style="height: calc( 100vh - 295px ); display: flex; align-items: center; justify-content: center;">
                        <div class="text-center">
                          <v-img 
                            class="mx-auto"
                            contain
                            alt="vuetify"
                            :width="90"
                            :height="90"
                            :src="require('@/assets/image/empty.png')">
                          </v-img>
                          <div class="mt-3 fs-16">
                            Silahkan Pilih {{ Object.keys(detail_project).length > 0 ? detail_project.duration_label === 'hari' ? 'Hari' : 'Minggu' : 'Minggu' }} Terlebih Dahulu
                          </div>
                        </div>
                      </v-card-text>
                      <v-card-text
                        v-if="process.load" 
                        class="pb-0 my-4" 
                        style="height: calc(100vh - 276px); display: flex; align-items: center; justify-content: center;">
                        <div class="text-center">
                          <div class="mb-4 title">
                            Mohon Tunggu . . .
                          </div>

                          <v-progress-linear
                            :color="set_color"
                            indeterminate
                            rounded
                            height="10">
                          </v-progress-linear>
                        </div>
                      </v-card-text>
                      <div v-if="!process.load && Object.keys(data_week).length > 0">
                        <div class="black--text font_weight_600 fs-14 mt-0 mb-2">
                          Tahapan Pekerjaan / rab
                        </div>
                        <v-card 
                          flat
                          style="border-radius: 10px; overflow-y: auto;">
                          <v-card-text class="pa-0">
                            <div :class="rab_array.length < 1 ? '' : 'wrapper_realisasi_kemajuan'" style="min-height: 550px;">
                              <table style="border: 1px solid #ededed; width: 100%; border-spacing: 0px; border-collapse: separate;" class="table">
                                <tr>
                                  <th rowspan="2" class="sticky-col one-checklist-col" style="font-size: 12px; border-spacing: 0px; border-collapse: separate; z-index: 3; border: 1px solid #fff; color: white; border-left: none; border-bottom: none; padding: 8px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" :style="`background-color: ${set_color};`">Jenis Pekerjaan (Uraian)</th>
                                  <th rowspan="2" class="sticky-col second-checklist-col" style="font-size: 12px; border-spacing: 0px; border-collapse: separate; border: 1px solid #fff; z-index: 3; color: white; border-left: none; border-bottom: none; padding: 8px 12px; text-align: left; width: 100%; min-width: 100%; max-width: 100%;" :style="`background-color: ${set_color};`">Satuan</th>
                                  <th rowspan="2" class="sticky-col three-checklist-col" style="font-size: 12px; border-spacing: 0px; border-collapse: separate; border: 1px solid #fff; z-index: 3; color: white; border-left: none; border-bottom: none; padding: 8px 12px; text-align: left; width: 100%; min-width: 100%; max-width: 100%;" :style="`background-color: ${set_color};`">Volume</th>
                                  <th rowspan="2" class="sticky-col four-checklist-col" style="font-size: 12px; border-spacing: 0px; border-collapse: separate; border: 1px solid #fff; z-index: 3; color: white; border-left: none; border-bottom: none; padding: 8px 12px; text-align: left; width: 100%; min-width: 100%; max-width: 100%;" :style="`background-color: ${set_color};`">Prosentase</th>
                                  <th colspan="3" class="text-capitalize" style="font-size: 12px; border-spacing: 0px; border-collapse: separate; border: 1px solid #fff; z-index: 2; color: white; border-left: none; border-bottom: none; padding: 8px 12px; text-align: center; width: 80px; min-width: 80px; max-width: 80px;" :style="`background-color: ${set_color};`">TAHAP PENYELESAIAN PEKERJAAN</th>
                                  <th rowspan="2" class="text-capitalize" style="font-size: 12px; border-spacing: 0px; border-collapse: separate; border: 1px solid #fff; z-index: 2; color: white; border-left: none; border-bottom: none; padding: 8px 12px; text-align: left; width: 80px; min-width: 80px; max-width: 80px;" :style="`background-color: ${set_color};`">TAHAP PENYELESAIAN TIAP BAGIAN PEKERJAAN</th>
                                  <th rowspan="2" class="text-capitalize" style="font-size: 12px; border-spacing: 0px; border-collapse: separate; border: 1px solid #fff; z-index: 2; color: white; border-left: none; border-bottom: none; padding: 8px 12px; text-align: left; width: 80px; min-width: 80px; max-width: 80px;" :style="`background-color: ${set_color};`">TAHAP PENYELESAIAN s/d {{ detail_project.duration_label === 'hari' ? 'HARI' : 'MINGGU' }} INI</th>
                                  <th rowspan="2" class="text-capitalize" style="font-size: 12px; border-spacing: 0px; border-collapse: separate; border: 1px solid #fff; z-index: 2; color: white; border-left: none; border-bottom: none; padding: 8px 12px; text-align: left; width: 80px; min-width: 80px; max-width: 80px;" :style="`background-color: ${set_color};`">TAHAP PENYELESAIAN TERHADAP SELURUH PEKERJAAN</th>
                                  <th rowspan="2" style="font-size: 12px; border-spacing: 0px; border-collapse: separate; border: 1px solid #fff; z-index: 2; color: white; border-left: none; border-bottom: none; padding: 8px 12px; text-align: left; width: 80px; min-width: 80px; max-width: 80px;" :style="`background-color: ${set_color};`">DEVIASI</th>
                                  <th rowspan="2" style="font-size: 12px; border-spacing: 0px; border-collapse: separate; border: 1px solid #fff; z-index: 2; color: white; border-left: none; border-bottom: none; padding: 8px 12px; text-align: left; width: 80px; min-width: 80px; max-width: 80px;" :style="`background-color: ${set_color};`">PROGRES</th>
                                  <th rowspan="2" style="font-size: 12px; border-spacing: 0px; border-collapse: separate; border: 1px solid #fff; z-index: 2; color: white; border-left: none; border-bottom: none; padding: 8px 12px; text-align: left; width: 80px; min-width: 80px; max-width: 80px;" :style="`background-color: ${set_color};`">KETERANGAN</th>
                                </tr>
                                <tr>
                                  <th style="top: 39px !important; font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 80px; min-width: 80px; max-width: 80px;" :style="`background-color: ${set_color};`">S/D {{ detail_project.duration_label === 'hari' ? 'Hari' : 'Minggu' }} Lalu</th>
                                  <th style="top: 39px !important; font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: right; width: 100px; min-width: 100px; max-width: 100px;" :style="`background-color: ${set_color};`">{{ detail_project.duration_label === 'hari' ? 'Hari' : 'Minggu' }} Ini</th>
                                  <th style="top: 39px !important; font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: right; width: 150px; min-width: 150px; max-width: 150px;" :style="`background-color: ${set_color};`">S/D {{ detail_project.duration_label === 'hari' ? 'Hari' : 'Minggu' }} Ini</th>
                                </tr>
                                <tr v-for="(item, index) in rab_array" :key="index">
                                  <td :class="item.num_children === 4  ? 'pl-11' : item.num_children === 3 ? 'd-flex' : ''" style="font-size: 12px; border-spacing: 0px; border-collapse: separate; background-color: #fff; padding: 8px 12px; text-align: left; border-left: none; border-bottom: none;" :style="item.num_children === 3 ? 'padding-left: 34px; border: 0.5px solid #ededed; min-width: 100%;' : item.num_children === 4 ? 'border: 0.5px solid #ededed; min-width: 100%;' : item.num_children === 1 ? 'padding-left: 18px; font-weight: 600; border: 1px solid #ededed;' : item.num_children === 0 ? 'font-weight: 700; border: 1px solid #ededed;' : 'padding-left: 24px; border: 1px solid #ededed;'" class="sticky-col one-checklist-col">
                                    <span v-if="item.code !== undefined">{{ item.code }}. </span>{{ item.name }}
                                  </td>
                                  <td class="sticky-col second-checklist-col" style="background-color: #fff; font-size: 12px; border-spacing: 0px; border-collapse: separate; border: 1px solid #ededed; padding: 8px 12px; border-left: none; border-bottom: none; text-align: left;">
                                    <!-- <span v-if="item.num_children === 3">
                                      {{ item.rencana_volume*1 }} {{ item.unit }}
                                    </span> -->
                                    <span v-if="item.num_children === 2">
                                      {{ item.unit }}
                                    </span>
                                  </td>
                                  <td class="sticky-col three-checklist-col" style="background-color: #fff; font-size: 12px; border-spacing: 0px; border-collapse: separate; border: 1px solid #ededed; padding: 8px 12px; border-left: none; border-bottom: none; text-align: left;">
                                    <!-- <span v-if="item.num_children === 3">
                                      {{ item.rencana_volume*1 }} {{ item.unit }}
                                    </span> -->
                                    <span v-if="item.num_children === 2">
                                      {{ item.volume*1 }}
                                    </span>
                                  </td>
                                  <td class="sticky-col four-checklist-col" style="background-color: #fff; font-size: 12px; border-spacing: 0px; border-collapse: separate; border: 1px solid #ededed; padding: 8px 12px; border-left: none; border-bottom: none; text-align: left;">
                                    <!-- <span v-if="item.num_children === 3">
                                      {{ item.rencana_volume*1 }} {{ item.unit }}
                                    </span> -->
                                    <span v-if="item.num_children === 2">
                                      {{ item.tahap_percent }}%
                                    </span>
                                  </td>
                                  <td style="font-size: 12px; border-spacing: 0px; border-collapse: separate; border: 1px solid #ededed; padding: 8px 12px; border-left: none; border-bottom: none; text-align: center; width: 150px; min-width: 150px; max-width: 150px;">
                                    <!-- <span v-if="item.num_children === 3">
                                      {{ item.rencana_volume*1 }} {{ item.unit }}
                                    </span> -->
                                    <span v-if="item.num_children === 2">
                                      {{ item.minggu_lalu }}
                                    </span>
                                  </td>

                                  <td class="black--text" style="font-size: 12px; border-spacing: 0px; border-collapse: separate; border: 1px solid #ededed; color: white; border-left: none; border-bottom: none; padding: 8px 8px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;">
                                    <div v-if="item.num_children === 2 && Object.keys(detail_project).length > 0 && detail_project.status !== 'Pelaksanaan'">
                                      {{ item.minggu_ini }}
                                    </div>  
                                    <div v-if="item.num_children === 2 && Object.keys(detail_project).length > 0 && detail_project.status === 'Pelaksanaan'">
                                      <ValidationProvider 
                                        :name="`Volume Realisasi ${item.name}`" 
                                        rules="required" 
                                        v-slot="{ errors, valid }">
                                        <v-currency-field
                                  
                                          filled
                                          rounded
                                          dense
                                          v-if="!process.load"
            
                                          :color="set_color"
                                          :auto-decimal-mode="false"
                                          :decimal-length="2"
                                          :allow-negative="false"
            
                                          hide-details
                                          v-on:change="item.minggu_total = (item.minggu_ini*1) + item.minggu_lalu"
            
                                          v-model="item.minggu_ini"
                                          :success="item.minggu_ini !== '' && valid"
                                          :error-messages="errors"
                                          required
                                          class="mb-0 fs-12 little-placeholder"
                                          style="border-radius: 6px;">
                                          <template v-slot:append-outer>
                                            <div v-if="errors.length > 0">
                                              <v-tooltip top color="#ff5252">
                                                <template v-slot:activator="{ on }">
                                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                                </template>
                                                
                                                {{ errors[0] }}
                                              </v-tooltip>
                                            </div>
            
                                            <div v-if="item.minggu_ini !== '' && valid">
                                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                                            </div>
                                          </template>
                                        </v-currency-field>
                                      </ValidationProvider>
                                    </div>
                                  </td>
                                  <td style="font-size: 12px; border-spacing: 0px; border-collapse: separate; border: 1px solid #ededed; padding: 8px 12px; border-left: none; border-bottom: none; text-align: center; width: 150px; min-width: 150px; max-width: 150px;">
                                    <!-- <span v-if="item.num_children === 3">
                                      {{ item.rencana_volume*1 }} {{ item.unit }}
                                    </span> -->
                                    <span v-if="item.num_children === 2">
                                      {{ item.minggu_total }}
                                    </span>
                                  </td>
                                  <td style="font-size: 12px; border-spacing: 0px; border-collapse: separate; border: 1px solid #ededed; padding: 8px 12px; border-left: none; border-bottom: none; text-align: left; width: 150px; min-width: 150px; max-width: 150px;">
                                    <!-- <span v-if="item.num_children === 3">
                                      {{ item.rencana_volume*1 }} {{ item.unit }}
                                    </span> -->
                                    <span v-if="item.num_children === 2">
                                      {{ item.volume === 0 ? 0 : ((((item.minggu_ini).toString().split(',').join('.')) / item.volume)*100).toFixed(2) }}%
                                    </span>
                                  </td>
                                  <td style="font-size: 12px; border-spacing: 0px; border-collapse: separate; border: 1px solid #ededed; padding: 8px 12px; border-left: none; border-bottom: none; text-align: left; width: 150px; min-width: 150px; max-width: 150px;">
                                    <!-- <span v-if="item.num_children === 3">
                                      {{ item.rencana_volume*1 }} {{ item.unit }}
                                    </span> -->
                                    <span v-if="item.num_children === 2">
                                      0
                                    </span>
                                  </td>
                                  <td style="font-size: 12px; border-spacing: 0px; border-collapse: separate; border: 1px solid #ededed; padding: 8px 12px; border-left: none; border-bottom: none; text-align: left; width: 150px; min-width: 150px; max-width: 150px;">
                                    <!-- <span v-if="item.num_children === 3">
                                      {{ item.rencana_volume*1 }} {{ item.unit }}
                                    </span> -->
                                    <span v-if="item.num_children === 2">
                                      0
                                    </span>
                                  </td>
                                  <td style="font-size: 12px; border-spacing: 0px; border-collapse: separate; border: 1px solid #ededed; padding: 8px 12px; border-left: none; border-bottom: none; text-align: left; width: 150px; min-width: 150px; max-width: 150px;">
                                    <!-- <span v-if="item.num_children === 3">
                                      {{ item.rencana_volume*1 }} {{ item.unit }}
                                    </span> -->
                                    <span v-if="item.num_children === 2">
                                      {{ item.volume === 0 ? 0 : ((item.minggu_ini*1) - ((item.volume*item.tahap_percent)/100).toFixed(2)) }}
                                    </span>
                                  </td>
                                  <td style="font-size: 12px; border-spacing: 0px; border-collapse: separate; border: 1px solid #ededed; padding: 8px 12px; border-left: none; border-bottom: none; text-align: left; width: 200px; min-width: 200px; max-width: 200px;">
                                    <!-- <span v-if="item.num_children === 3">
                                      {{ item.rencana_volume*1 }} {{ item.unit }}
                                    </span> -->
                                    <div v-if="item.num_children === 2 && Object.keys(detail_project).length > 0 && detail_project.status !== 'Pelaksanaan'">
                                      {{ item.progress }}
                                    </div>  
                                    <div v-if="item.num_children === 2 && Object.keys(detail_project).length > 0 && detail_project.status === 'Pelaksanaan'">
                                      <span v-if="item.num_children === 2">
                                        <ValidationProvider 
                                          :name="`Progres ${item.name}`" 
                                          rules="" 
                                          v-slot="{ errors, valid }">
                                          <v-select
                                    
                                            filled
                                            rounded
                                            dense
              
                                            :color="set_color"
  
                                            :items="['Sesuai', 'Mendahului', 'Terlambat']"
              
                                            hide-details
              
                                            v-model="item.progress"
                                            :success="item.progress !== '' && valid"
                                            :error-messages="errors"
                                            
                                            class="mb-0 fs-12 little-placeholder"
                                            style="border-radius: 6px;">
                                            <template v-slot:append-outer>
                                              <div v-if="errors.length > 0">
                                                <v-tooltip top color="#ff5252">
                                                  <template v-slot:activator="{ on }">
                                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                                  </template>
                                                  
                                                  {{ errors[0] }}
                                                </v-tooltip>
                                              </div>
              
                                              <div v-if="item.progress !== '' && valid">
                                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                                              </div>
                                            </template>
                                          </v-select>
                                        </ValidationProvider>
                                      </span>
                                    </div>
                                  </td>
                                  <td style="font-size: 12px; border-spacing: 0px; border-collapse: separate; border: 1px solid #ededed; padding: 8px 12px; border-left: none; border-bottom: none; text-align: left; width: 350px; min-width: 350px; max-width: 350px;">
                                    <!-- <span v-if="item.num_children === 3">
                                      {{ item.rencana_volume*1 }} {{ item.unit }}
                                    </span> -->
                                    <div v-if="item.num_children === 2 && Object.keys(detail_project).length > 0 && detail_project.status !== 'Pelaksanaan'">
                                      {{ item.note }}
                                    </div>  
                                    <div v-if="item.num_children === 2 && Object.keys(detail_project).length > 0 && detail_project.status === 'Pelaksanaan'">
                                      <span v-if="item.num_children === 2">
                                        <ValidationProvider 
                                          :name="`Keterangan ${item.name}`" 
                                          rules="" 
                                          v-slot="{ errors, valid }">
                                          <v-text-field
                                    
                                            filled
                                            rounded
                                            dense
              
                                            :color="set_color"
              
                                            hide-details
              
                                            v-model="item.note"
                                            :success="item.note !== '' && valid"
                                            :error-messages="errors"
                                            
                                            class="mb-0 fs-12 little-placeholder"
                                            style="border-radius: 6px;">
                                            <template v-slot:append-outer>
                                              <div v-if="errors.length > 0">
                                                <v-tooltip top color="#ff5252">
                                                  <template v-slot:activator="{ on }">
                                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                                  </template>
                                                  
                                                  {{ errors[0] }}
                                                </v-tooltip>
                                              </div>
              
                                              <div v-if="item.note !== '' && valid">
                                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                                              </div>
                                            </template>
                                          </v-text-field>
                                        </ValidationProvider>
                                      </span>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </div>


                          </v-card-text>
                        </v-card>
                      </div>
                    </v-form>
                  </ValidationObserver>
                </v-col>
              </v-row>


              <v-row
                justify="end"
                class="pa-4 pb-2"
                v-if="Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? false : true : false">
                <v-col 
                  cols="12"
                  md="9">
                </v-col>
                <v-col 
                  cols="12"
                  md="3"
                  class="d-flex align-center justify-end py-0">
                  <v-btn
                    @click="save()"
                    :loading="process.form"
                    :disabled="process.form || Object.keys(detail_project).length > 0 ? detail_project.status !== 'Pelaksanaan' ? true : false : true"
                    elevation="0"
                    rounded
                    color="success"
                    style="border-radius: 6px; font-weight: 600;"
                    class="fs-14 white--text text-capitalize">
                    <v-icon
                      size="20">
                      mdi-checkbox-marked-circle-outline
                    </v-icon>
    
                    <span
                      class="ml-2">
                      Simpan
                    </span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
  
        </section>
      </v-flex>
    </v-layout>
  </div>
  </template>
  
  <script>
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          unit: [],
          detail_project: {},
          dialog: {
            snackbar: false,
            confirm: false,
            fullscreen: false
          },
          selected: {
            status: '',
            confirm: [],
            delete: []
          },
          count_week_list: [],
          count_week: 0,
          form: {
            id: '',
            spk_number: '',
            spk_date: '',
            request_file_object: [],
            request_file: [],
            request_image: [],
            type_file: 'image',
            duration: '',
            rab_value: '',
            contract_value: '',
            pj_implementation: '',
            start_date: '',
            end_date: '',
            holiday: '',
          },
          data_week: {},
          filename: [],
          upload: {
            image: null,
            document: null,
            image_process: null,
            document_process: null
          },
          rab_array: [],
          all_document: [],
          all_document_process: [],
          client: [],
          location: [],
          show: false,
          upload: {
            image: null
          },
  
          process: {
            form: false,
            load: false,
  
            image: false,
            document: false,
            image_process: false,
            document_process: false,
            status: false
          },
          
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
        uploadimage: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue'),
        uploadfile: () => import(/* webpackPrefetch: true */ '@/components/upload/document.vue'),
      },
      watch: {
        'upload.image': {
          handler: function () {
            if (this.upload.image) {
              // this.form.request_file_object.type = 'image'
              this.message.error = ''
              this.process.image = this.upload.image.process
  
              if (!this.process.image) {
                // CALLBACK FROM UPLOAD IMAGE
                this.form.request_image.push({
                  title: '',
                  url: this.upload.image.fileuri,
                  type: 'image',
                  no_surat: '',
                  tgl_surat: ''
                })
                this.all_document.push({
                  title: '',
                  url: this.upload.image.fileuri,
                  type: 'image',
                  no_surat: '',
                  tgl_surat: ''
                })
  
                this.upload.image = null
  
                // this.form.request_file_object.url = this.upload.image.fileuri
              }
            }
          },
          deep: true
        },
        'upload.document': {
          handler: function () {
            if (this.upload.document) {
              // this.form.request_file_object.type = 'file'
              this.message.error = ''
              this.process.document = this.upload.document.process
              
              if (!this.process.document) {
                var regexp = /\.([0-9a-z]+)(?:[\?#]|$)/i;
                var extension = this.upload.document.fileuri.match(regexp);
                // CALLBACK FROM UPLOAD IMAGE
                this.filename.push(this.upload.document.filename)
                this.form.request_file.push({
                  title: '',
                  url: this.upload.document.fileuri,
                  type: extension && extension[1],
                  no_surat: '',
                  tgl_surat: ''
                })
                this.all_document.push({
                  title: '',
                  url: this.upload.document.fileuri,
                  type: extension && extension[1],
                  no_surat: '',
                  tgl_surat: ''
                })
  
                this.upload.document = null
  
                // this.form.request_file_object.url = this.upload.document.fileuri
              }
            }
          },
          deep: true
        },
        'upload.image_process': {
          handler: function () {
            if (this.upload.image_process) {
              // this.form.request_file_object.type = 'image'
              this.message.error = ''
              this.process.image_process = this.upload.image_process.process
  
              if (!this.process.image_process) {
                // CALLBACK FROM UPLOAD IMAGE
                this.form.request_process_image.push({
                  title: '',
                  url: this.upload.image_process.fileuri,
                  type: 'image',
                  no_surat: '',
                  tgl_surat: ''
                })
                this.all_document_process.push({
                  title: '',
                  url: this.upload.image_process.fileuri,
                  type: 'image',
                  no_surat: '',
                  tgl_surat: ''
                })
                this.upload.image_process = null
  
                // this.form.request_file_object.url = this.upload.image.fileuri
              }
            }
          },
          deep: true
        },
  
        'upload.document_process': {
          handler: function () {
            if (this.upload.document_process) {
              // this.form.request_file_object.type = 'file'
              this.message.error = ''
              this.process.document_process = this.upload.document_process.process
              
              if (!this.process.document_process) {
                var regexp = /\.([0-9a-z]+)(?:[\?#]|$)/i;
                var extension = this.upload.document_process.fileuri.match(regexp);
                // CALLBACK FROM UPLOAD IMAGE
                this.filename.push(this.upload.document_process.filename)
                this.form.request_process_file.push({
                  title: '',
                  url: this.upload.document_process.fileuri,
                  type: extension && extension[1],
                  no_surat: '',
                  tgl_surat: ''
                })
                this.all_document_process.push({
                  title: '',
                  url: this.upload.document_process.fileuri,
                  type: extension && extension[1],
                  no_surat: '',
                  tgl_surat: ''
                })
                this.upload.document_process = null
  
                // this.form.request_file_object.url = this.upload.document.fileuri
              }
            }
          },
          deep: true
        }
        
      },
      computed: {
        user () {
          return this.$store.state.user
        },
        outlet () {
          return this.$store.state.outlet
        },
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        }
      },
      mounted () {
        this.fetchDetail()
      },
      methods: {
        async fetchDetail () {
          let params = {
            id: this.$route.params.id
          }
  
          await get(`project/detail`, { params })
          .then(response => {
            let res = response.data
  
            if (res.status === 200) {
              this.detail_project = res.results.data
              this.count_week = res.results.data.rab_duration*1
              for (let i = 1; i <= this.detail_project.rab_duration; i++) {
                this.count_week_list.push(
                  {
                    id: (i*1)-1,
                    value: `${this.detail_project.duration_label === 'hari' ? 'Hari' : 'Minggu'} Ke - ${i}`
                  }
                )
              }
            }
          })
        },

        async fetchDetailRealisasiKemajuanPekerjaanWeek () {
          this.process.load = true
          let params = {
            id: this.$route.params.id,
            week: this.selected.week+1
          }
  
          await get(`project/progress/checklist/data`, { params })
          .then(response => {
            let res = response.data
  
            if (res.status === 200) {
              this.data_week = res.results
              this.rab_array = []
              res.results.data.map((item, index_par) => {
                this.rab_array.push({
                  ...item,
                  num_children: 0,
                  // no_par: '',
                  par_id: '0',
                  // is_child: item.child.length > 0 ? true : false
                })
                if(item.child.length > 0){
                  item.child.map((child1, index) => {
                    if(child1.child.length > 0){
                      this.rab_array.push(
                        {
                          ...child1,
                          par_id : item.id,
                          num_children: 1,
                        }
                      )
                      child1.child.map((child2, index2) => {
                        this.rab_array.push(
                          {
                            ...child2,
                            par_id: child1.id,
                            num_children: 2,
                            // no: index2 + 1,
                            // is_child: false,
                            volume: child2.volume*1,
                            minggu_lalu: child2.minggu_lalu*1, 
                            minggu_ini: (child2.minggu_ini*1).toString().split('.').join(','), 
                            minggu_total: child2.minggu_total*1, 
                            tahap_percent: child2.tahap_percent*1
                          }
                        )
                      })
                    } else {
                      this.rab_array.push(
                        {
                          ...child1,
                          num_children: 1,
                          par_id: item.id,
                          // is_child: false
                        }
                      )
                    }
                  }
                  )
                }
              })
              this.process.load = false

              // console.log(this.rab_array)
              // res.results.data.rab_array.map((child2, index2) => {
              //   this.rab_array.push(
              //     {
              //       ...child2,
              //       par_id: '0',
              //       num_children: 2,
              //       no: index2 + 1,
              //       is_child: false
              //     }
              //   )
              //   if(child2.detail.length > 0) {
              //     child2.detail.map((child3, index3) => {
              //       this.rab_array.push({
              //         ...child3,
              //         par_id: child2.id,
              //         num_children: 3,
              //         col: child3.col
              //       })
              //     })
              //   }
              // })
            }
          })
        },
  
        // async save () {
        //   this.message.error = ''
  
        //   this.form.request_file = this.all_document.filter(item => item.type !== 'image')
        //   this.form.request_image = this.all_document.filter(item => item.type === 'image')
  
        //   const isValid = await this.$refs.form.validate(),
        //         isDocument = this.form.request_file.length > 0 || this.form.request_image.length > 0
        //   this.message.error = !isValid ? 'Silahkan lengkapi form' : !isDocument ? 'Dokumen Negosiasi harus diisi' :''
        //   if (isValid && isDocument) {
        //     this.process.form = true
  
        //     // SAVE TO REST API
        //     await post(`project/negotiation`, {
        //       data: {
        //         id: this.form.id,
        //         negotiation_final_object: {file :{
        //           "doc": this.form.request_file,
        //           "image": this.form.request_image
        //         }}
        //       }
        //     })
        //     .then((response) => {
        //       let res = response.data
  
        //       this.process.form = false
  
        //       if (res.status === 200) {
  
        //         this.dialog.snackbar = true
        //         this.message.success = res.message
  
        //         this.fetch()
  
        //       } else {
        //         this.message.error = res.message
        //       }
        //     })
            
        //   } else {
        //     // AUTO FOCUS ON TEXT-FIELD
        //     setTimeout(() => {
        //       const errors = Object.entries(this.$refs.form.errors)
        //         .map(([key, value]) => ({ key, value }))
        //         .filter(error => error['value'].length)
        //       this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
        //         behavior: 'smooth',
        //         block: 'center'
        //       })
        //     }, 10)
        //   }
        // },
        async save () {
          this.message.error = ''

  
          const isValid = await this.$refs.form.validate()
          this.message.error = !isValid ? 'Silahkan lengkapi form' : ''
          if (isValid) {
            this.process.form = true

            const rab = []

            this.rab_array.map(item => {
              if(item.minggu_ini !== undefined) {
                item.minggu_ini = (item.minggu_ini).toString().split(',').join('.')
              }
              
            })

            this.rab_array.map(item => {
              if(item.par_id === '0') {
                rab.push(
                  {
                    ...item,
                    child: []
                  }
                )
              } 
              
            })
            rab.map(item => {
              this.rab_array.map(child => {
                if(child.par_id === item.id && child.num_children === 1) {
                  item.child.push(
                    {
                      ...child,
                      child: []
                    }
                  )
                }
              })
            })

            rab.map(item => {
              item.child.map(child => {
                this.rab_array.map(child2 => {
                  if(child2.par_id === child.id && child2.num_children === 2) {
                    child.child.push(
                      {
                        ...child2
                      }
                    )
                  }
                })
              })
            })

            // this.rab_array.map(item => {
            //   if (item.par_id === '0') {
            //     rab.push(
            //       {
            //         ...item,
            //         detail: []
            //       }
            //     )
            //   }
            // })

            // rab.map((item, index) => {
            //   this.rab_array.map(child => {
            //     if (child.par_id === item.id) {
            //       rab[index].detail.push(child)
            //     }
            //   })
            // })
            let form = {
              id: this.$route.params.id,
              week: this.selected.week+1,
              data_array: rab
            }
            // console.log(form)
            // console.log(this.data_week)
  
            // SAVE TO REST API
            await post(`project/progress/checklist/update`, {
              data: form
            })
            .then((response) => {
              let res = response.data
  
              this.process.form = false
  
              if (res.status === 200) {
  
                this.dialog.snackbar = true
                this.message.success = res.message
  
                this.fetchDetailPelaksanaanWeek()
  
              } else {
                this.message.error = res.message
              }
            })
            
          } else {
            // AUTO FOCUS ON TEXT-FIELD
            setTimeout(() => {
              const errors = Object.entries(this.$refs.form.errors)
                .map(([key, value]) => ({ key, value }))
                .filter(error => error['value'].length)
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }, 10)
          }
        },
        async statuses () {
          this.message.error = ''
          this.process.status = true
  
          // SAVE TO REST API
          await post(`project/status`, {
            data: {
              id: this.$route.params.id,
              status: this.selected.status
            }
          })
          .then((response) => {
            let res = response.data
  
            this.process.form = false
  
            if (res.status === 200) {
              this.dialog.snackbar = true
              this.dialog.confirm = false
              this.dialog.fullscreen = false
              this.message.success = res.message
              if (this.selected.status === 'Negosiasi') {
                this.$router.push(`/project/process/negosiasi/${this.form.id}`)
              } else {
                this.$router.push(`/project/process/penawaran/${this.form.id}`)
              }
              this.$emit('reloaddata')
  
            } else {
              this.message.error = res.message
            }
          })
        }
      }
    }
  </script>
  
  <style>
  table, th, td {
    /* border: 1px solid #ededed;
    border-collapse: collapse; */
    /* border: thin ridge black; */
    border-spacing: 4px;
    border-collapse: collapse;
  }
  
  .view {
    margin: auto;
    width: 100%;
  }
  
  .wrapper_realisasi_kemajuan th { 
    position: sticky; 
    top: 0; 
    /* background-color: #080679 !important; */
  } 

  .one-checklist-col {
    width: 200px;
    min-width: 200px;
    max-width: 200px;
    left: 0px;
    z-index: 3;
  }

  .second-checklist-col {
    width: 100px;
    min-width: 100px;
    max-width: 100px;
    left: 200px;
    z-index: 3;
  }

  .sticky-col {
    position: -webkit-sticky;
    position: sticky;
    /* background-color: #080679 !important; */
  }

  .three-checklist-col {
    width: 100px;
    min-width: 100px;
    max-width: 100px;
    left: 300px;
    z-index: 3;
  }

  .four-checklist-col {
    width: 100px;
    min-width: 100px;
    max-width: 100px;
    left: 400px;
    z-index: 3;
  }
  tr:hover {background-color: #1976d236;}
  tr.selected {background-color: #1976d236;}
  </style>